module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_Vitra02.0104.png.d6ccc86b.jpg";